import { Plugin } from 'prosemirror-state';

export default () => {
    const plugin = new Plugin({
        state: {
            init() {
                return false;
            },
            apply(transaction, pluginState) {
                if (transaction.getMeta('reset-has-changes')) {
                    return false;
                }
                return pluginState || transaction.docChanged;
            }
        }
    });
    return plugin
}